/**
 * @desc 根据投诉id查询投诉详情信息
 */
import { ComplaintItem } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryOperationComplaintItemParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/operation/complaint'

export const queryOperationComplaintItemApi = (
  params?: QueryOperationComplaintItemParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ComplaintItem>({
    method,
    url,
    params,
    ...config
  })
}

queryOperationComplaintItemApi.method = method
queryOperationComplaintItemApi.url = url
